// extracted by mini-css-extract-plugin
export default {"ranking_item":"RankingItem_ranking_item__zN-zr","self":"RankingItem_self__0zD-5","rank":"RankingItem_rank__kmHz+","inner":"RankingItem_inner__C+w6l"};